export default __webpack_public_path__ + "static/media/redmine-logo.f850402a.svg";